import { useRef, useEffect } from 'react';

/**
 * @param delay Milisaniye cinsinden aralık. `null` verilirse zamanlayıcı hiç
 *   kurulmaz — koşullu yoklamalarda ("modal açıkken sor") kullanılır. Fonksiyon
 *   zaten `delay !== null` kontrolü yapıyordu, tip imzası bunu yansıtmıyordu.
 */
const useInterval = (callback: any, delay: number | null) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      (savedCallback as any).current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export default useInterval;
